module.exports = __webpack_public_path__ + "static/img/hoverlogo12.8c1f4f26.png";